import * as React from "react";
import { IconProps } from "../types";

const PenWritingOutlineIcon = React.forwardRef<SVGSVGElement, IconProps>(
  ({ color = "currentColor", ...props }, forwardedRef) => {
    return (
      <svg
        width="18"
        height="18"
        fill="none"
        viewBox="0 0 18 18"
        xmlns="http://www.w3.org/2000/svg"
        ref={forwardedRef}
        {...props}
      >
        <path
          d="M3.75 15.25C3.75 15.25 7.349 14.682 8.296 13.735C9.243 12.788 15.623 6.40799 15.623 6.40799C16.46 5.57099 16.46 4.21399 15.623 3.37799C14.786 2.54099 13.429 2.54099 12.593 3.37799C12.593 3.37799 6.213 9.75799 5.266 10.705C4.319 11.652 3.751 15.251 3.751 15.251L3.75 15.25Z"
          stroke={color}
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M8.25 2.75H1.75"
          stroke={color}
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M4.25 6.25H1.75"
          stroke={color}
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </svg>
    );
  },
);

export default PenWritingOutlineIcon;
